import { Deserializable } from '../protocols/deserializable';

export class BaseType implements Deserializable {
  public id!: number;
  public name!: string;

  onDeserialize(): void {}
}
